import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { TEntryField } from '../../data/ProcData'
import { TSteadyStep, TTimelineStep } from '../../data/WorkflowSteps'
import aGetFormCompletion from './aGetFormCompletion'
import DF, { DataViewNumberField as VF } from './DataNumberField'
import EntryItem from './RampupEntryItem'
import { useAppDispatch, useAppSelector } from './RunReduxHooks'
import { selectProcHeader } from './sliceRunProcHeader'
import { recalculateStaticCompliance, selectData } from './sliceTimeline'

export const fieldList: TEntryField[] = [
    'LAPressure', 'PAPressure',
    'PerfusateFlow', 'PumpSpeed',
    'PeakAWP', 'MeanAWP', 'PlateauAWP',
    'DynamicCompliance'
]

export default function ATab2SystemData({ completion }: { completion: (allChecked: boolean) => void }) {
    const { step } = useParams()
    const dispatch = useAppDispatch()
    const stepData = useAppSelector(selectData)
    const procHeader = useAppSelector(selectProcHeader)
    const currentStep = step as TSteadyStep
    const timelineStep = step as TTimelineStep
    const plateauAWP = stepData[currentStep]?.PlateauAWP

    useEffect(() => {
        completion(aGetFormCompletion(stepData, currentStep, fieldList))
    }, [stepData, currentStep, completion])

    useEffect(() => {
        if (step === undefined) {
            return
        }

        dispatch(recalculateStaticCompliance({
            step: timelineStep,
            assessmentVV_mL: procHeader?.assessmentVV_mL,
            PEEP_cmH20: procHeader?.PEEP_cmH20
        }))
    }, [
        dispatch,
        step,
        timelineStep,
        plateauAWP,
        procHeader?.assessmentVV_mL,
        procHeader?.PEEP_cmH20
    ])

    const GRIDSPACING = 2

    return (
        <>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={6}>
                        <DF step={step} field='PAPressure' fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        <DF step={step} field='LAPressure' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={4}>
                        <DF step={step} field='PerfusateFlow' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='PumpSpeed' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <VF step={step} field='PVResistance' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={4}>
                        <DF step={step} field='PeakAWP' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='MeanAWP' fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <DF step={step} field='PlateauAWP' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>
            <EntryItem>
                <Grid container spacing={GRIDSPACING}>
                    <Grid item xs={6}>
                        <DF step={step} field='DynamicCompliance' fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        <VF step={step} field='StaticCompliance' fullWidth />
                    </Grid>
                </Grid>
            </EntryItem>
        </>
    )
}